import React, { useEffect, useState } from "react";
import { Typography } from "@material-ui/core";
import { useIntl } from "react-intl";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { getDiseaseDetail } from "../../../services/commonservices";
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";
import TitleSubtitle from "../TitleSubtitle";
import { useSelector } from "react-redux";
import { isSearchSymptoms } from "../../../utils/utils";

const useStyles = makeStyles((theme) => ({
  diseaseTextBlock: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    color: "black",
  },
  blockTitle: {
    fontWeight: "bold",
    color: theme.palette.secondary.main,
  },
  paragraph: {
    whiteSpace: "pre-line",
  },
  title: {
    fontWeight: "bold",
  },
  symptomSelected: {
    color: `${theme.palette.selected.main} !important`,
  },
}));

const DiseaseDetailComponent = ({ id, symptoms_score }) => {
  const intl = useIntl();
  const classes = useStyles();

  const [detail, setDetail] = useState(null);

  const selectedSymptoms = useSelector((state) => state.searchOmim.selectedSymptoms);
  const selectedPatientSymptoms = useSelector((state) => state.patient.symptoms);

  const allSelectedSymptoms = selectedSymptoms.concat(selectedPatientSymptoms);

  const diseaseCallback = (response) => {
    setDetail(response.data);
  };

  useEffect(() => {
    id && getDiseaseDetail(id, diseaseCallback);
  }, [id]);

  const phenotypesValues = [
    "mimNumber",
    "phenotype",
    "phenotypeMimNumber",
    "phenotypeMappingKey",
    "phenotypeInheritance",
    "sequenceID",
    "chromosome",
    "chromosomeSymbol",
    "chromosomeSort",
    "chromosomeLocationStart",
    "chromosomeLocationEnd",
    "cytoLocation",
    "geneSymbols",
    "geneName",
  ];

  return (
    <>
      {detail ? (
        <div className={classes.diseaseTextBlock}>
          {detail?.description && (
            <>
              <Typography variant={"h5"} className={classes.blockTitle}>
                {intl.formatMessage({ id: "description" })}
              </Typography>
              <Typography variant={"body1"} className={classes.paragraph}>
                {detail?.description}
              </Typography>
            </>
          )}
          {detail?.mapping && (
            <>
              <Typography variant={"h5"} className={classes.blockTitle}>
                {intl.formatMessage({ id: "mapping" })}
              </Typography>
              <Typography variant={"body1"} className={classes.paragraph}>
                {detail?.mapping}
              </Typography>
            </>
          )}
          {detail?.molecularGenetics && (
            <>
              <Typography variant={"h5"} className={classes.blockTitle}>
                {intl.formatMessage({ id: "molecular_genetics" })}
              </Typography>
              <Typography variant={"body1"} className={classes.paragraph}>
                {detail?.molecularGenetics}
              </Typography>
            </>
          )}
          {detail?.text && (
            <>
              <Typography variant={"h5"} className={classes.blockTitle}>
                {intl.formatMessage({ id: "text" })}
              </Typography>
              <Typography variant={"body1"} className={classes.paragraph}>
                {detail?.text}
              </Typography>
            </>
          )}
          {!!Object.keys(detail.symptoms)?.length && (
            <>
              <Typography variant={"h5"} className={classes.blockTitle}>
                {intl.formatMessage({ id: "symptoms_and_signs" })}
              </Typography>
              <Grid container spacing={4}>
                {Object.keys(detail.symptoms).map((category, index) => (
                  <Grid item sm={12} md={3} key={`${category}-${index}`}>
                    <Typography className={classes.title}>{category}</Typography>
                    {detail.symptoms[category].All.map((symptom, index) => (
                      <Typography
                        key={`${symptom.id}-${index}`}
                        variant={"body2"}
                        className={isSearchSymptoms(symptom.name, allSelectedSymptoms) && classes.symptomSelected}
                      >
                        {symptom.name}
                      </Typography>
                    ))}
                  </Grid>
                ))}
              </Grid>
            </>
          )}
          {!!detail.phenotypes?.length && (
            <>
              <Typography variant={"h5"} className={classes.blockTitle}>
                {intl.formatMessage({ id: "phenotypes" })}
              </Typography>
              {detail.phenotypes.map((type, index) => (
                <Grid container spacing={4} key={`${type}-${index}`}>
                  {phenotypesValues.map(
                    (value, index) =>
                      type[value] && (
                        <Grid item sm={12} md={3} key={`${type[value]}-${index}`}>
                          <TitleSubtitle title={intl.formatMessage({ id: value })} subtitle={type[value]} />
                        </Grid>
                      ),
                  )}
                  {!!type.geneIds?.length && (
                    <Grid item sm={12} md={3}>
                      <Typography className={classes.title}>{intl.formatMessage({ id: "geneIds" })}</Typography>
                      {type.geneIds.map((gene, index) => (
                        <Typography variant={"body2"} key={`${gene}-${index}`}>
                          {gene}
                        </Typography>
                      ))}
                    </Grid>
                  )}
                </Grid>
              ))}
            </>
          )}
             {!!symptoms_score &&
                 <>
                   <Typography variant={"h5"} className={classes.blockTitle}>
                     {intl.formatMessage({ id: "score" })}
                   </Typography>
                   <Grid container spacing={4}>
                     <Grid item sm={12} md={3}>
                       {symptoms_score}
                     </Grid>
                   </Grid>
                 </>
             }

        </div>
      ) : (
        <CircularProgress color={"secondary"} />
      )}
    </>
  );
};

export default DiseaseDetailComponent;
